export default __webpack_public_path__ + "static/media/codeclan-graduation-rMIN.8a57878b.jpg";